import { gql } from "gql";

export const GENERATE_POST_TITLE = gql(/* GraphQL */ `
  subscription GeneratePostTitle($content: String!) {
    aiGenerateTitle(content: $content) {
      ... on UpdateMessageAiChatMessage {
        text
      }
    }
  }
`);
